import Intranet from "@/layouts/intranet/Index.vue";
import crudUpdate from "@/components/crud_ag/actions/Update";

export default {
  path: "/products",
  component: Intranet,
  redirect: { name: "productsCrud" },
  meta: {
    title: "Articles",
  },
  children: [
    {
      path: "list",
      name: "productsCrud",
      component: () => import("@/views/crud/ArticuloCrud.vue"),
      meta: {
        auth: true,
        serviceName: "articles",
        title: "Llista d'articles",
      },
      children: [
        {
          path: ":id",
          name: "productsCrudUpdate",
          component: crudUpdate,
          meta: {
            auth: true,
            serviceName: "articles",
            title: "Articles",
          },
        },
      ],
    },
    {
      path: "categories",
      name: "componentFamiliesCrud",
      component: () => import("@/views/crud/ArticuloFamiliaCrud.vue"),
      meta: {
        auth: true,
        serviceName: "article-families",
        title: "Famílies d'articles",
      },
      children: [
        {
          path: ":id",
          name: "componentFamiliesCrudUpdate",
          component: crudUpdate,
          meta: {
            auth: true,
            serviceName: "article-families",
            title: "Família d'articles",
          },
        },
      ],
    },
  ],
};
